import { useState, MouseEvent } from 'react';
import { Control, Controller } from 'react-hook-form';
import TextField, { StandardTextFieldProps } from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { IconButton } from '@mui/material';
import { Container } from './styles';

export interface InputPasswordControlledProps extends StandardTextFieldProps {
  control: Control;
  name: string;
}

export const InputPassword = ({
  name,
  control,
  sx,
  ...rest
}: InputPasswordControlledProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <Container sx={sx}>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({
          field: { onChange, value, onBlur, ref },
          fieldState: { error },
        }) => (
          <TextField
            type={showPassword ? 'text' : 'password'}
            value={value}
            onBlur={onBlur}
            onChange={onChange}
            ref={ref}
            error={!!error}
            helperText={error ? error.message : null}
            InputProps={{
              endAdornment: (
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
            {...rest}
          />
        )}
      />
    </Container>
  );
};
